import { type IMessage } from "@/interfaces/api/message.interface"
import { BaseModelWithFiles } from "@/models/base-with-files.model"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { ModelFactory } from "@/factories/model-factory"

export class Message extends BaseModelWithFiles implements IMessage {
  public static className = "Message" // Used for socket communication.
  public static verboseName = "bericht"

  public static managedResolveFields = ["messenger"]

  id: string

  order: string

  messenger: KnownBusinessEntityContact

  body: string

  isPrepared: boolean

  constructor(message: IMessage, managed = false) {
    super(message, managed)
    this.id = message.id
    this.order = message.order
    this.messenger = ModelFactory.childModel(KnownBusinessEntityContact, message.messenger, managed)
    this.body = message.body
    this.isPrepared = message.isPrepared
  }
}
